import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { NAVBAR_STATE_KEY } from './definitions/nav-bar.definitions';
import { navbarReducer } from './reducers/nav-bar.reducers';

@NgModule({
  imports: [StoreModule.forFeature(NAVBAR_STATE_KEY, navbarReducer)],
})
export class NavbarModule {}
